var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManyToOneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01568 10.6569C7.78577 10.6569 10.0314 8.41126 10.0314 5.64117C10.0314 2.87109 7.78577 0.625488 5.01568 0.625488C2.2456 0.625488 0 2.87109 0 5.64117C0 8.41126 2.2456 10.6569 5.01568 10.6569Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01568 24.8541C7.78577 24.8541 10.0314 22.6085 10.0314 19.8384C10.0314 17.0684 7.78577 14.8228 5.01568 14.8228C2.2456 14.8228 0 17.0684 0 19.8384C0 22.6085 2.2456 24.8541 5.01568 24.8541Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5215 25.109C40.2916 25.109 42.5372 22.8634 42.5372 20.0933C42.5372 17.3232 40.2916 15.0776 37.5215 15.0776C34.7515 15.0776 32.5059 17.3232 32.5059 20.0933C32.5059 22.8634 34.7515 25.109 37.5215 25.109Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01568 38.881C7.78577 38.881 10.0314 36.6354 10.0314 33.8653C10.0314 31.0952 7.78577 28.8496 5.01568 28.8496C2.2456 28.8496 0 31.0952 0 33.8653C0 36.6354 2.2456 38.881 5.01568 38.881Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6L21 20",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 35L21.0481 20.0183",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20L41 20",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManyToOneIcon);
export default __webpack_public_path__ + "static/media/ManyToOneIcon.d5324aac13618f16902c59f2694b0312.svg";
export { ForwardRef as ReactComponent };